import {
  Button,
  PageHeader,
  ProjectDetailTabs,
  useAuth,
  useCall,
} from "@nexys/user-management-web";
import { ChevronLeft } from "lucide-react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

export const ProjectDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { hasUserRole } = useAuth();
  const project = useCall("getProject", { projectId: id ?? "" });

  if (!id) return <Navigate to="/products" replace />;
  if (!hasUserRole("superadmin")) return <Navigate to="/" replace />;

  return (
    <div className="grid gap-6">
      <PageHeader
        title={project.data?.name ?? "Product"}
        description="Tenants and settings for this product."
        actions={
          <Button variant="outline" size="sm" onClick={() => navigate("/products")}>
            <ChevronLeft /> Back
          </Button>
        }
      />
      <ProjectDetailTabs
        projectId={id}
        canManage
        canDelete
        onDeleted={() => navigate("/products")}
        onSelectTenant={(tenantId) => navigate(`/tenants/${tenantId}`)}
      />
    </div>
  );
};
